module.exports = __webpack_public_path__ + "media/images/eraf_sunstar_lv-32fe83cda0252f5903fe59af407420c9.svg";